export default __webpack_public_path__ + "static/media/me.7caf5ce3.png";